import { AfterViewInit, Component, inject } from "@angular/core";
import {
  UntypedFormControl,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule
} from "@angular/forms";
import { ZoneStore } from "@app/services/store/zone-store";
import { Zone } from "@app/models/rest/zone";
import { ActivatedRoute, Router } from "@angular/router";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogActions
} from "@angular/material/dialog";
import {
  defaults as defaultControls,
  FullScreen,
  ScaleLine,
  ZoomToExtent
} from "ol/control.js";
import {
  defaults as defaultInteractions,
  DragRotateAndZoom
} from "ol/interaction.js";
import { fromLonLat } from "ol/proj";
import TileLayer from "ol/layer/Tile";
import { OSM } from "ol/source";
import View from "ol/View";
import Map from "ol/Map";
import { MatFormField, MatError } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatButton } from "@angular/material/button";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-zone-create",
  templateUrl: "./zone-create.component.html",
  styleUrls: ["./zone-create.component.scss"],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatInput,
    MatError,
    MatDialogActions,
    MatButton,
    TranslatePipe
  ]
})
export class ZoneCreateComponent implements AfterViewInit {
  protected zoneStore = inject(ZoneStore);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  dialogRef = inject<MatDialogRef<ZoneCreateComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  zoneForm = new UntypedFormGroup({
    name: new UntypedFormControl(""),
    area: new UntypedFormControl("")
  });

  ngAfterViewInit(): void {
    new Map({
      layers: [
        new TileLayer({
          source: new OSM()
        })
      ],
      controls: defaultControls().extend([
        new ZoomToExtent({
          extent: [
            813079.7791264898, 5929220.284081122, 848966.9639063801,
            5936863.986909639
          ]
        }),
        new FullScreen(),
        new ScaleLine()
      ]),
      interactions: defaultInteractions().extend([new DragRotateAndZoom()]),
      target: "map",
      view: new View({
        center: fromLonLat([2, 45]),
        zoom: 6
      })
    });
  }

  onCreateZone() {
    console.warn(this.zoneForm.value);

    let zone: Zone = this.zoneForm.value;
    this.zoneStore.create(zone).subscribe(
      (value) => {
        console.log(value);
        console.log("success");
        this.dialogRef.close({ success: true });
        this.router.navigate([".."], { relativeTo: this.route });
      },
      (error) => {
        console.log("error creating zone");
        // TODO parse correct field from response
        this.zoneForm.controls["area"].setErrors({
          server: error.error.cause.cause.message
        });
      }
    );
  }

  getErrorMessage(controlName: string) {
    console.log(this.zoneForm.controls[controlName].errors);
    console.log("get error");
    return this.zoneForm.controls[controlName].errors.server;
  }

  onCancelButton() {
    this.dialogRef.close();
  }
}
